import { useState, useEffect } from 'react';
import SmallMultiFilter from '../custom/SmallMultiFilter';
import { getKnjigeLokacije } from "../../util/apiKnjiga";
import { useToast } from '@chakra-ui/react';

const KnjigeSelect=({selectedKnjige=[],onKnjigeSelect})=>{
    const [stKnjige,setStKnjige]=useState([]);
    const [err,setErr]=useState("");
    const toast=useToast;
    useEffect(() => {
        const fetchKnjige=async()=>{
            try {
              const _res=await getKnjigeLokacije();
              if (_res.status===200) {
                setStKnjige(_res.res);
              } else {
                throw new Error(_res.message);
              }
            } catch (error) {
              setErr(error.message);
            }
          }

          fetchKnjige();
    }, []);

    const knjigeSelected=(x)=>{
        onKnjigeSelect(x);
      }
      const showPosjednike=()=>{
        if (err!=="") {
            toast({
                title:"Greška kod dohvata knjiga.",
                status:"error",
                description:err,
                isClosable:true,
                duration:3000,
                position:"top-right",
            });
        }
        if (stKnjige.length!==0) {
          return (
            
            <SmallMultiFilter size='xs' data={stKnjige} selectedid={selectedKnjige} showheader={true} dataheader='' idfieldname='knjiga_id' textfieldname='knjiga' onSelect={(x)=>{onKnjigeSelect(x)}}/>
            
          )
        }
       }
    return (
        <>
            {showPosjednike()}
        </>
    )
}

export default KnjigeSelect;